import React from 'react';

function Header() {


  const articles = [
    { name: "Normal V Poisson", href: "/articles/normalvpoisson" },
    { name: "Financial Calculator", href: "/articles/financialcalculator" },
    { name: "Frequency Analysis", href: "/articles/frequencyanalysis" },
  ];

  return (
    <header className="border-b border-gray-200 bg-white fixed w-full left-0 top-0 z-[1000]">
      <nav className="max-w-6xl mx-auto px-6 py-4">
        <ul className="flex gap-16 items-center">
          <li className=''>
            <a 
              href="/" 
              className="text-gray-900 font-semibold hover:text-gray-600 transition-colors"
            >
              Home
            </a>
          </li>
          <li className="relative group">
            <button className="text-gray-900 font-semibold hover:text-gray-900">
              Articles
            </button>

            <div className="absolute left-0 top-full w-48 bg-white border border-gray-200 rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-150">
              <ul className="py-2">
                {articles.map((article, index) => (
                  <li key={index}>
                    <a
                      href={article.href}
                      className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                    >
                      {article.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </li>
          <li className=''>
            <a
              href='/resume'
              className="bg-black rounded-lg px-8 py-2 hover:bg-gray-700 text-white font-semibold transition-colors"
            >
              Resume
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
